import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "load",
  "use": "load-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"load\"><defs><style>#load .cls-1{opacity:0;}</style></defs><title>资源 2</title><g id=\"load_图层_2\" data-name=\"图层 2\"><g id=\"load_图层_1-2\" data-name=\"图层 1\"><g class=\"cls-1\"><path d=\"M11,22A11,11,0,1,1,22,11,11,11,0,0,1,11,22ZM11,2a9,9,0,1,0,9,9A9,9,0,0,0,11,2Z\" /></g><path d=\"M11,22A11,11,0,0,1,11,0a1,1,0,0,1,0,2,9,9,0,0,0,0,18,1,1,0,0,1,0,2Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/load.svg
// module id = 83p3
// module chunks = 264